import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CurrentAuthenticationState, Token } from '@warema/shared/authentication/models';
import { User } from '@warema/shared/models';

/** Platform-specific: register via provideAuthentication(environment) (browser) or provideAuthenticationServer() (SSR). */
@Injectable({
    providedIn: 'root',
    useFactory: (): never => {
        throw new Error(
            'No implementation for AuthenticationApiService. Add provideAuthentication(environment) or provideAuthenticationServer() to your app config.',
        );
    },
})
export abstract class AuthenticationApiService {
    public loggedIn$ = new BehaviorSubject<boolean>(false);
    public language$ = new BehaviorSubject<string>('');
    public userLoaded$ = new BehaviorSubject<boolean>(false);
    public firstName$ = new BehaviorSubject<string>('');
    public lastName$ = new BehaviorSubject<string>('');
    public name$ = new BehaviorSubject<string>('');
    public email$ = new BehaviorSubject<string>('');
    public id$ = new BehaviorSubject<string>('');
    public locale$ = new BehaviorSubject<string>('');
    public authenticationComplete$ = new BehaviorSubject<boolean>(false);
    public token$ = new BehaviorSubject<Token | null>(null);

    public abstract get currentAuthenticationState$(): Observable<CurrentAuthenticationState>;
    public abstract get user$(): BehaviorSubject<User | null>;
    public abstract init(loadUserCallback?: () => Promise<void>): Promise<void>;
    public abstract login(redirectUri?: string): Promise<void>;
    public abstract register(redirectUri?: string): Promise<void>;
    public abstract logout(): Promise<void>;
    public abstract logoutWithPopup(): void;
    public abstract loginWithPopup(): Promise<void>;
    public abstract closeLoginPopup(): void;
    public abstract addRegisteredFlag(): void;
}
